// extracted by mini-css-extract-plugin
export default {"overlay":"Modal__overlay--slots-j0h9h","modal":"Modal__modal--slots-hTXcZ"};